import { render, staticRenderFns } from "./ItemTable.vue?vue&type=template&id=7166d3eb&scoped=true&"
import script from "./ItemTable.vue?vue&type=script&lang=js&"
export * from "./ItemTable.vue?vue&type=script&lang=js&"
import style0 from "./ItemTable.vue?vue&type=style&index=0&id=7166d3eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7166d3eb",
  null
  
)

export default component.exports